(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-commercial-benefits"] && !Shopify.designMode) return;
  try {
    class ProductCommercialBenefits extends HTMLElement {
    connectedCallback() {
      this.eventScope = this.closest('product-card, .shopify-section, dialog');
      this.eventScope?.addEventListener('variant:update', this.handleVariantUpdate);
    }

    disconnectedCallback() {
      this.eventScope?.removeEventListener('variant:update', this.handleVariantUpdate);
    }

    handleVariantUpdate = (event) => {
      const eventProductId = event.detail?.data?.newProduct?.id || event.detail?.data?.productId;

      if (eventProductId && String(eventProductId) !== this.dataset.productId) return;

      const html = event.detail?.data?.html;
      if (!html) return;

      const escapedBlockId = CSS.escape(this.dataset.blockId || '');
      const selector = `product-commercial-benefits[data-block-id="${escapedBlockId}"]`;
      const replacement = html.querySelector(selector);

      if (!replacement) return;

      this.dataset.productId = replacement.dataset.productId || this.dataset.productId;
      this.dataset.available = replacement.dataset.available || this.dataset.available;
      this.innerHTML = replacement.innerHTML;
    };
  }

  if (!customElements.get('product-commercial-benefits')) {
    customElements.define('product-commercial-benefits', ProductCommercialBenefits);
  }
  } catch(e) { console.error(e); }
})();

})();
